import { Component, OnInit, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { SVGIcon, filePdfIcon, fileExcelIcon, pencilIcon, trashIcon } from '@progress/kendo-svg-icons';
import { process } from '@progress/kendo-data-query';
import { StepperModule, TabStripModule } from '@progress/kendo-angular-layout';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ExcelExportModule } from "@progress/kendo-angular-excel-export";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { PDFExportModule } from "@progress/kendo-angular-pdf-export";
import { PDFViewerModule } from "@progress/kendo-angular-pdfviewer";
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteModalComponent } from 'app/confirm-delete-modal/confirm-delete-modal.component';
import { GridService } from 'app/services/grid.service';
import { PageService } from 'app/services/page.service';
import { SelectEvent } from '@progress/kendo-angular-charts';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DrakeCustomComponentComponent } from 'app/drake-components/drake-custom-component/drake-custom-component.component';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { TranslocoPipe } from '@ngneat/transloco';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { MatIcon } from '@angular/material/icon';
import { StepperStep } from '@progress/kendo-angular-layout';


@Component({
  selector: 'app-drake-custom-page',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    TabStripModule,
    HttpClientModule,
    ExcelExportModule,
    ButtonsModule,
    PDFExportModule,
    PDFViewerModule,
    MatDialogModule,
    DrakeCustomComponentComponent,
    TranslocoPipe,
    LayoutModule,
    StepperModule,
    MatIcon
  ],
  templateUrl: './drake-custom-page.component.html',
  styleUrl: './drake-custom-page.component.scss'
})
export class DrakeCustomPageComponent implements OnInit, OnChanges {
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
  public pageData: any;
  public baseData: any = {  };
  public currentWizardStep: number = 0;
  public wizardSteps: Array<StepperStep> = [];
  constructor(private router: Router, private activatedRoute: ActivatedRoute, pageService: PageService, drakeShared: DrakeSharedService) {
    drakeShared.currentBaseData = this.baseData;
    this.activatedRoute.params.subscribe(params => {
      pageService.getPage(params?.['pageCode']).subscribe((result: any) => {
        this.pageData = result;
        this.initWizardSteps();
        drakeShared.currentPageData = result;

      });
    })

  }

  ngOnChanges(changes: SimpleChanges): void {
    // Quando pageData viene caricato o cambia, prepara gli step del wizard
    if (changes['pageData'] && this.pageData?.pageTabs) {
      this.initWizardSteps();
    }
  }

  initWizardSteps() {
    this.wizardSteps = this.pageData.pageTabs.map((tab: any, index: number) => {
      return {
        label: tab.tabTitle, 
      };
    });
  }

  nextStep() {
    if (this.currentWizardStep < this.wizardSteps.length - 1) {
      this.currentWizardStep += 1;
    } else {
      // Logica per quando il wizard è finito (es. Salva / Invia)
      console.log('Wizard completato!');
    }
  }

  public onValueChange(event: any): void {
    console.log("Ricevuto evento dal custom component:", event);

    if (event && event.action === 'NEXT_STEP') {
      this.nextStep();
    }
    
    if (event && event.action === 'PREV_STEP') {
      this.prevStep();
    }
  }

  prevStep() {
    if (this.currentWizardStep > 0) {
      this.currentWizardStep -= 1;
    }
  }

  public get showNextButton(): boolean {
    if (!this.pageData || !this.pageData.pageTabs) return true;
    
    const currentTab = this.pageData.pageTabs[this.currentWizardStep];
    if (!currentTab || !currentTab.tabComponents) return true;

    const hasNoNextComponent = currentTab.tabComponents.some((c: any) => c.componentType === 'WIZ_NO_NEXT');
    
    return !hasNoNextComponent;
  }

  public get showPrevButton(): boolean {
    if (!this.pageData || !this.pageData.pageTabs) return true;
    
    const currentTab = this.pageData.pageTabs[this.currentWizardStep];
    if (!currentTab || !currentTab.tabComponents) return true;

    const hasNoPrevComponent = currentTab.tabComponents.some((c: any) => c.componentType === 'WIZ_NO_PREV');
    
    return !hasNoPrevComponent;
  }

  public get showButtons(): boolean {
    if (!this.pageData || !this.pageData.pageTabs) return true;
    
    const currentTab = this.pageData.pageTabs[this.currentWizardStep];
    if (!currentTab || !currentTab.tabComponents) return true;

    const hasNoButtonComponent = currentTab.tabComponents.some((c: any) => c.componentType === 'WIZ_NO_BTN');
    
    return !hasNoButtonComponent;
  }

  ngOnInit(): void {
  }

  public onTabSelect(e: SelectEvent): void {
    console.log(e);
  }

}
